"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containUpperCase = exports.containSymbol = exports.containNumber = exports.containLowerCase = void 0;

var containUpperCase = function containUpperCase(value) {
  return /[A-Z]/.test(value);
};

exports.containUpperCase = containUpperCase;

var containLowerCase = function containLowerCase(value) {
  return /[a-z]/.test(value);
};

exports.containLowerCase = containLowerCase;

var containNumber = function containNumber(value) {
  return /[0-9]/.test(value);
};

exports.containNumber = containNumber;

var containSymbol = function containSymbol(value) {
  return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
};

exports.containSymbol = containSymbol;